import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import React from "react";

import { tokens } from "./tokens";

interface Props {
    url: string;
    enabled: boolean;
}

const useStyles = makeStyles(() => ({
    link: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "15px",
        fontWeight: 500,
        color: tokens.accent,
        background: tokens.accentSoft,
        border: `1px solid ${tokens.accentLine}`,
        borderRadius: "9px",
        padding: "10px 16px",
        cursor: "pointer",
        textDecoration: "none",
        verticalAlign: "middle",
        "&:hover": {
            filter: "brightness(1.04)",
        },
        "& svg": {
            width: "18px",
            height: "18px",
        },
    },
    disabled: {
        opacity: 0.5,
        cursor: "not-allowed",
    },
}));

export const CommissioningLinkButton: React.FC<Props> = ({ url, enabled }) => {
    const classes = useStyles();

    if (!enabled) {
        return (
            <Tooltip title="Enable maintenance mode to access this link">
                <span className={`${classes.link} ${classes.disabled}`} aria-disabled="true">
                    <OpenInNewRoundedIcon />
                    Open Commissioning Site
                </span>
            </Tooltip>
        );
    }

    return (
        <a
            className={classes.link}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open Commissioning Site in new tab"
        >
            <OpenInNewRoundedIcon />
            Open Commissioning Site
        </a>
    );
};
